import styles from './TravelDefaultTeaser.module.scss'
import { Card } from 'react-bootstrap'
import Link from 'next/link'
import travelObject from '@/entities/travel/interface'
import CloudinaryImage from '@/components/elements/media/CloudinaryImage'
import { buildTravelDatesLabel } from '@/lib/helpers/travel'
import { formatPrice } from '@/lib/helpers/helpers'
import { useTranslation } from 'next-i18next'
import TeaserFlag from '@/components/elements/TeaserFlag'

interface Props {
  travel: travelObject
  trackingStringPrefix: string
}

const TravelDefaultTeaser = ({ travel, trackingStringPrefix }: Props) => {
  const { t } = useTranslation('common')

  return (
    <>
      <Link
        href={`/tour/${travel.seoSettings.urlSlug}`}
        className={styles.wrap}
        data-tr-click={`${trackingStringPrefix}_travel_teaser:click`}
        data-tr-view={`${trackingStringPrefix}_travel_teaser:view`}
      >
        <Card className={styles.card + ' an-up'}>
          <div className="img-ratio-16-9">
            <CloudinaryImage
              image={travel.mainImage}
              className={'card-img'}
              altDefault={travel.name}
              aspectRatio={1.777}
              width={527}
              responsive={false}
              placeholderClassName={'position-absolute'}
            />
          </div>
          {travel.label && <TeaserFlag text={travel.label.label} />}
          <Card.Body className={styles.body}>
            <Card.Title className={styles.title}>{travel.name}</Card.Title>
            <Card.Text as={'div'}>
              <div className={styles.date} dangerouslySetInnerHTML={{ __html: buildTravelDatesLabel(travel.pricing.travels, t) }} />
              <div className={styles.price}>
                {travel.minPrice > 0 ? (
                  <>{`${t('booking.priceFrom')} ${formatPrice(travel.minPrice, travel.currency)}`}</>
                ) : (
                  t('booking.priceFollows')
                )}
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </Link>
    </>
  )
}

export default TravelDefaultTeaser
